import { httpInstance } from '@/services/httpInstance';

const getRemittancesService = async () => {
  let res;
  const endpoint = '/back-office/v1/remittances/all';
  await httpInstance.get(
    endpoint,
  ).then((data) => {
    res = data;
  }).catch((err) => {
    res = err.response;
  });
  return res;
};

export default getRemittancesService;
